import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import styles from './DefaultBar.module.css'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Col, Row } from 'react-bootstrap';
import { Height } from '@material-ui/icons';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default function DefaultBar({ data }) {
  const maxValue = useMemo(() => Math.max(...data.datasets.reduce((acc, curr) => [...acc, ...curr.data], [])), [data])
  const height = useMemo(() => data?.labels?.length * 80, [data])

  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Количество проектов, шт.',
        position: 'left',
        font: { size: 16, weight: 500, family: 'Open Sans' },
        color: "#7F7F7F",
        padding: {
          bottom: 29,
        }
      },
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
      datalabels: {
        align: 'right',
        anchor: 'end',
        color: 'black',
        display: true,
        formatter: (value) => String(value.toFixed(3)).replace('.', ','),
        labels: {
          title: {
            font: {
              weight: 'bold',
              size: 14
            }
          },
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 14,
            weight: 600,
          },
          color: '#7F7F7F',
        },
        suggestedMax: maxValue + 20,
        beginAtZero: true,
      },
      y: {
        ticks: {
          font: {
            size: 14,
            weight: 600,
            family: 'Open Sans'
          },
          color: '#424242',
          crossAlign: 'start'
        },
      }
    },
  };

  const totals = useMemo(() => {
    return data.datasets.map(dataset => dataset.data.reduce((acc, curr) => acc + curr, 0))
  }, [data])

  return (
    <div>
      <div style={{maxHeight: height, marginLeft: '-45px'}}>
        <Bar height={height} data={data} options={options} plugins={[ChartDataLabels]}  style={{ height, minHeight: height }}/>
      </div>
      <Row>
        <Col style={{marginTop: '38px'}} xs={12}>
          <ul className={styles.legend}>
            <li className={styles.legendItem}>
              <span>{totals[0] ? totals[0].toFixed(3).replace('.', ',') : 0}</span>
              <div className={styles.legendBox} style={{backgroundColor: '#696969'}}/>
              <p>из гранта</p>
            </li>
            <li className={styles.legendItem}>
              <span>{totals[1] ? totals[1].toFixed(3).replace('.', ',') : 0}</span>
              <div className={styles.legendBox} style={{backgroundColor: '#DDDDDD'}}/>
              <p>из внебюджета</p>
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );
}
